import { buildMachineUserAnalytics, MachineUserEvent, MachineUserHeartbeat } from './machine-user-analytics';

export type UserChecklist = { stamp?: string; user?: string | number | null };
export type UserDay = { key: string; start: Date; end: Date; hours: number; crashes: number; holes: number; checklists: number };

export function machineUserWeek(now = new Date()): Array<Pick<UserDay, 'key' | 'start' | 'end'>> {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = (type: string) => parts.find(p => p.type === type)?.value;
  const today = new Date(`${part('year')}-${part('month')}-${part('day')}T00:00:00-03:00`);
  return Array.from({ length: 14 }, (_, i) => {
    const start = new Date(today.getTime() - (13 - i) * 86400000);
    const key = new Date(start.getTime() - 3 * 3600000).toISOString().slice(0, 10);
    return { key, start, end: new Date(Math.min(start.getTime() + 86400000, now.getTime())) };
  });
}

export function buildMachineUserWeek(selectedUser: string, heartbeats: MachineUserHeartbeat[],
  events: MachineUserEvent[], checklists: UserChecklist[], now = new Date()): UserDay[] {
  const aliases = Number.isFinite(Number(selectedUser)) ? [String(Number(selectedUser))] : [];
  const users = new Set([selectedUser, ...aliases]);
  return machineUserWeek(now).map(day => {
    const inDay = (stamp?: string) => {
      const t = stamp ? new Date(stamp).getTime() : NaN;
      return t >= day.start.getTime() && t < day.start.getTime() + 86400000 && t <= day.end.getTime();
    };
    const analytics = buildMachineUserAnalytics({
      selectedUser, selectedUserAliases: aliases, heartbeats,
      events: events.filter(event => inDay(event.stamp)), rangeStart: day.start, rangeEnd: day.end,
    });
    return { ...day, hours: analytics.totalWorkHours, crashes: analytics.crashCount,
      holes: analytics.holeCount,
      checklists: checklists.filter(c => users.has(String(c.user ?? '')) && inDay(c.stamp)).length };
  });
}
